<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="70%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div id="box" style="margin-bottom:30px;padding:30px">
          <h1 style="text-align: center; font-size:30px;  font-weight: 600;">{{this.item}}缴费通知单</h1>
    <div style="margin-top:20px">尊敬的业主 ({{this.customerName}}) ,您好！</div>
    <br/>
     <div>您在{{this.address}}的应交款项如下：</div>
       <el-table  :data="tableData"   style="float:right;margin-top:30px;margin-bottom:30px" 
              row-key="id" border  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column prop="feeItem.feeName" label="收费项目" ></el-table-column>
    <el-table-column prop="zjCny" label="应收期间" ></el-table-column>
    <el-table-column prop="lastReading" label="上月读数" ></el-table-column>
    <el-table-column prop="thisReading" label="本月读数" ></el-table-column>
    <el-table-column prop="buildArea" label="耗量/面积" ></el-table-column>
    <el-table-column prop="zjJe" label="应收金额" ></el-table-column>
    <el-table-column prop="ZJE" label="往月欠费" ></el-table-column>
    <el-table-column prop="zjRemarks" label="截止发单日滞纳金" ></el-table-column>
    <el-table-column prop="HJE" label="合计金额" ></el-table-column>
    <el-table-column prop="zjRemarks" label="备注" ></el-table-column>
  </el-table>
  <div>备注：</div>
    <br/>
  <div style="margin-left:20px">{{this.startDescription}}</div>
  <br/>
  <div style="margin-left:40px">账户名称：{{this.bankAccountName}}</div>
    <br/>
  <div style="margin-left:40px">开户行：{{this.bankDeposit}}</div>
    <br/>
  <div style="margin-left:40px">银行账户：{{this.bankAccount}}</div>
    <br/>
  <div style="margin-left:40px">请在转账时备注房号、对应的月份及收费项目。如：1栋101房11月物业费</div>
    <br/>
<div style="margin-left:20px">2.如逾期未收到以上费用‎，‎我司将按合同‎约‎定的违约金费率‎，据此通知缴费截止日的次日起，按日计算收取滞纳金。</div>
<br/>
<div style="margin-left:20px">3.电费:当年欠费部分，每日按欠费总额的千分之二计算；跨年度欠费部分，每日按欠费总额的千分之三计算。物业费和生活垃圾费：逾期交纳的 ，从逾期之日起每日加收应交纳费用的千分之五的滞纳金;若欠费期超过1个月，物业有权进行书面催缴；若欠费期超过3个月，物业将对其停止物业服务，并有权向人民法院提起诉讼追缴欠费。</div>
<br/>
<div style="margin-left:20px;margin-bottom:30px">4.如有疑问‎，‎欢迎您致电服务中心‎：{{this.phone}}，‎我们将竭诚为您服务‎。</div>
<div class="sty">
  <div style="margin-top:55px;margin-left:35px">{{this.projectName}}物业服务处</div>
  <br/>
  <div style="margin-left:25px">发单日期：{{this.time}}</div>
</div>
  </div>
  <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" v-print="printObj" >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
 components: {},
  name: "PaymentPrintDialog",
  data() {
    return {
        dialogVisible: false,
        title:"标题",
        item:"",
        tableData: [],
        customerName:"",
        address:"",
        chargePrompt:[],
        startDescription:"",
        bankAccountName:"",
        bankDeposit:"",
        bankAccount:"",
        projectName:"",
        phone:"",
        time:"",
        roomId:[],
        projectId:"",
        JsonArr:[],
        printObj:{
            id:'box',
            //其他配置项，
         }
    };
  },
   watch: {
     dialogVisible(val){
       if(val == true){
         
         this.PrintInform()
       }
     },
  },
  methods: {
    handleClose(done) {
      this.dialogVisible = false
    },
    PrintInform(){
      let obj = {
        "projectId":this.projectId,
        "json":this.JsonArr,
      "roomId":this.roomId
      }
      this.$http.post(this.$requestUrl.POST_PRINT,obj).then((res)=>{
        let dat = res.data
        let date = dat.data
        this.tableData = date
        for(let val of date){
          if(val.tableType == null){
            val.ZJE = val.zjJe * (val.num -1)
            val.HJE = val.zjJe * (val.num-1)+ val.zjJe + val.late
          }else{
            val.ZJE = val.zjCedj - val.zjJe
            val.HJE = val.zjCedj + val.late
          }
          

          if(val.chargePrompt){
            if(val != null){
              this.chargePrompt = val.chargePrompt
              for(let arr of val.chargePrompt){
                this.startDescription = arr.startDescription
                this.bankAccountName = arr.bankAccountName
                this.bankDeposit = arr.bankDeposit
                this.bankAccount = arr.bankAccount
                this.phone = arr.phone
              }
            }
          }
        }
      })
    },
      getDate(){
	    	let date = new Date();
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
            let hh = new Date().getHours()
            let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes():new Date().getMinutes()
            let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds():new Date().getSeconds()
	    	let arr = ['星期天','星期一','星期二','星期三','星期四','星期五','星期六'];
	    	let day = date.getDay();
            // let time = year+"-"+month+"-"+dates+" "+hh+":"+mf+":"+ss
            // this.time = time
            this.time = year+"/"+month+"/"+dates
            // console.log('今天是：'+ year +'年' + month + '月' + dates + '日' + hh +":"+ mf+":"+ ss + arr[day])
	    },
  },
  mounted() {
    this.getDate()
  },

}
</script>

<style scoped lang="scss">
.sty{
  width: 200px;
  height: 145px;
  border: 1px solid #fff;
  margin-left: 720px;
  margin-bottom: 30px;
   background-image: url(http://oa-sh-test.xinfu.info/newerp/static/images/prompt/3e0caba3c97549519c26baa3f733be2a.png);
  background-size: cover;
  background-repeat: no-repeat;
}
</style>